import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import ArchitectsDaughterRegular from "./ArchitectsDaughter-Regular.woff2";

export const ArchitectsDaughterFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: ArchitectsDaughterRegular,
    descriptors: {
      weight: "400",
      style: "normal",
    },
  },
];
